import React, { PropsWithChildren } from 'react';
import Grid from '@/components/Grid/Grid';
import Container from '@/components/Container/Container';
import { SxProps } from '@mui/material';

/**
 * @interface Props
 * @extends {PropsWithChildren}
 */
interface Props extends PropsWithChildren {
  /**
   * The class name of the layout
   * @type {string}
   */
  className?: string;
  /**
   * The style of the layout
   * @type {React.CSSProperties}
   */
  style?: React.CSSProperties;
  /**
   * The style of the layout using sx prop
   * @type {SxProps}
   */
  sx?: SxProps;
  /**
   * The style of the container using sx prop
   * @type {SxProps}
   */
  containerSx?: SxProps;
}

const GridSpacingLayout = (props: Props) => {
  const { style, sx, containerSx, className, children } = props;
  return (
    <Grid container className={className} style={style} sx={sx} justifyContent={'center'}>
      <Container sx={containerSx}>{children}</Container>
    </Grid>
  );
};

export default GridSpacingLayout;
